import styled from 'styled-components/macro'
import { ReactComponent as AsSvg } from 'src/assets/img/tpeLogos/tpePlayerWhite_noCircle.svg'

export const Image = styled(AsSvg)`
  width: 75px;
  @media (min-width: 650px) {
    width: 85px;
  }
`
